{
  "1 à 5": "1 a 5",
  "A chassé le plus de bad vibes": "Espantou mais bad vibes",
  "A chassé les boss": {
    "one": "Espantou o chefão",
    "many": "Espantou os chefões",
    "other": "Espantou os chefões"
  },
  "A ramassé le plus de vibes": "Pegou mais vibes",
  "A relevé l’équipe": "Levantou a equipe",
  "Agir": "Ações",
  "Agrès": "Aparelhos",
  "Alliés soignés": "Aliados curados",
  "Alt": "Alt",
  "Alt Gr": "Alt Gr",
  "Ambyss": "Ambyss",
  "Anneaux solaires": "Anéis Solares",
  "Apprendre à jouer": "Aprender a jogar",
  "Approche une bad vibe : tu tires tout seul": "Chegue perto de uma bad vibe: você atira sozinho",
  "Appuie sur Entrée ou sur A pour rejoindre": "Aperte Enter ou A para entrar",
  "Appuie…": "Aperte…",
  "Après chaque kick, trois étincelles qui transpercent.": "Depois de cada kick, três faíscas que atravessam.",
  "Après le dernier boss, la nuit continue": "Depois do último chefão, a noite continua",
  "Arc-en-ciel du drop": "Arco-Íris do Drop",
  "Assiettes chinoises": "Pratos Chineses",
  "Attire": "Atrai",
  "Aucun salon ne porte ce code": "Nenhuma sala tem esse código",
  "Automatique": "Automático",
  "Autre": "Outro",
  "Avant de lancer": "Antes de começar",
  "Avec tes amis": "Com seus amigos",
  "B2B : {recipe}": "B2B: {recipe}",
  "Backstage": "Backstage",
  "Bad vibes": "Bad vibes",
  "Bad vibes dissipées": "Bad vibes dissipadas",
  "Baisser le son": "Abaixar o som",
  "Balaie la foule de loin avec ses poi lumineux. Fragile.": "Varre a multidão de longe com seus poi luminosos. Frágil.",
  "Balaie un arc d'une ligne de lumière qui dissout les bad vibes.": "Varre um arco com uma linha de luz que dissolve as bad vibes.",
  "Banane": "Pochete",
  "Bas": "Baixo",
  "Baskets légères": "Tênis Leves",
  "Bonnes ondes": "Boas Vibrações",
  "Boss": "Chefões",
  "Boss vaincu": "Chefão derrotado",
  "Boucle VJ": "Loop de VJ",
  "Boule à facettes": "Globo Espelhado",
  "Bouton {number}": "Botão {number}",
  "Boutons par défaut remis.": "Botões padrão restaurados.",
  "Bras grands ouverts": "Braços Bem Abertos",
  "Break": "Break",
  "Brume du lac": "Névoa do Lago",
  "Bug": "Bug",
  "Bâton de feu": "Bastão de Fogo",
  "Bâton du diable": "Devil Stick",
  "Caisson de basse": "Subwoofer",
  "Ce bouton garde son rôle, choisis-en un autre.": "Esse botão mantém a função dele, escolha outro.",
  "Ce code est déjà pris, réessaie": "Esse código já está em uso, tente de novo",
  "Ce code n’est pas valide": "Esse código não é válido",
  "Ce que tu as vécu, ce que tu attendais, ce que tu changerais.": "O que você viveu, o que esperava, o que mudaria.",
  "Cerceaux": "Bambolês",
  "Cette touche garde son rôle, choisis-en une autre.": "Essa tecla mantém a função dela, escolha outra.",
  "Chacun prend une place avec son clavier ou sa manette.": "Cada um pega um lugar com o teclado ou o controle.",
  "Chaque dash laisse ta traînée au sol deux mesures.": "Cada dash deixa seu rastro no chão por dois compassos.",
  "Charge": "Investida",
  "Choisi": "Escolhida",
  "Choisir": "Escolher",
  "Choisir la scène": "Escolher o palco",
  "Choisir un piège": "Escolher armadilha",
  "Choisis d’abord le type de ton avis.": "Escolha primeiro o tipo da sua opinião.",
  "Choisis la scène": "Escolha o palco",
  "Choisis tes touches et tes boutons": "Escolha suas teclas e botões",
  "Choisis ton amélioration": "Escolha sua melhoria",
  "Choisis ton perso": "Escolha seu personagem",
  "Choix de la scène": "Escolha do palco",
  "Choix du perso": "Escolha do personagem",
  "Choix d’amélioration": "Escolha de melhoria",
  "Classe": "Classe",
  "Classe précédente": "Classe anterior",
  "Classe suivante": "Próxima classe",
  "Classe · {className}": "Classe · {className}",
  "Classes": "Classes",
  "Clavier et souris": "Teclado e mouse",
  "Clic droit": "Clique direito",
  "Clic gauche": "Clique esquerdo",
  "Clic molette": "Clique do meio",
  "Code du salon": "Código da sala",
  "Colle le code ici": "Cole o código aqui",
  "Connexion impossible ({message})": "Não foi possível conectar ({message})",
  "Connexion perdue": "Conexão perdida",
  "Console de mixage": "Mesa de Som",
  "Contexte de la partie": "Contexto da partida",
  "Contrôles": "Controles",
  "Copie impossible ici. Ton avis reste dans l’onglet GitHub.": "Não dá para copiar aqui. Sua opinião continua na aba do GitHub.",
  "Copie impossible ici. Ton texte est sélectionné : copie-le à la main.": "Não dá para copiar aqui. Seu texto está selecionado: copie à mão.",
  "Copier": "Copiar",
  "Copier le lien": "Copiar o link",
  "Copié dans le presse-papiers.": "Copiado para a área de transferência.",
  "Coupé": "Mudo",
  "Croix": "Direcional",
  "Crée un salon pour inviter tes amis, ou rejoins le leur avec son code.": "Crie uma sala para convidar seus amigos, ou entre na deles com o código.",
  "Créer un salon": "Criar uma sala",
  "Ctrl": "Ctrl",
  "Ctrl droite": "Ctrl direito",
  "Câble d'or": "Cabo de Ouro",
  "C’est plutôt": "É mais",
  "Dash": "Impulso",
  "Debout": "De pé",
  "Des spores, à porter à un géant": "Esporos, para levar a um gigante",
  "Deux bâtons frappent tout autour de toi à chaque temps.": "Dois bastões batem ao seu redor a cada tempo.",
  "Deux éventails tournent autour de toi sans jamais s’arrêter.": "Dois leques giram ao seu redor sem parar nunca.",
  "Deuxième souffle": "Segundo Fôlego",
  "Diabolo": "Diabolô",
  "Didacticiel": "Tutorial",
  "Double bâton": "Bastão Duplo",
  "Double faisceau": "Feixe Duplo",
  "Double tempo": "Tempo Dobrado",
  "Downtempo, dub": "Downtempo, dub",
  "Droite": "Direita",
  "Drop": "Drop",
  "Débriefe ton set sur Discord": "Conte do seu set no Discord",
  "Début": "Home",
  "Défends le sound system jusqu’au lever du soleil.": "Defenda o sound system até o nascer do sol.",
  "Défense": "Defesa",
  "Départ": "Início",
  "Déplace-toi": "Ande",
  "Elle vide l'énergie de tout ce qui brille.": "Drena a energia de tudo o que brilha.",
  "En attente de l’hôte": "Esperando o anfitrião",
  "En attente de {players}": "Esperando {players}",
  "En attente d’un joueur": "Esperando um jogador",
  "En ligne": "Online",
  "En ligne, la pause n’arrête pas le set : ton personnage reste immobile pendant que les autres jouent.": "Online, a pausa não para o set: seu personagem fica parado enquanto os outros jogam.",
  "Enceintes": "Caixas",
  "Enceintes branchées": "Caixas ligadas",
  "Entrée": "Enter",
  "Envoie le code ou le lien à tes amis, puis lance le set.": "Mande o código ou o link para seus amigos e depois comece o set.",
  "Envoie une onde de basse sur chaque temps et repousse les bad vibes.": "Solta uma onda de grave a cada tempo e empurra as bad vibes.",
  "Envoyer sur GitHub": "Enviar no GitHub",
  "Espace": "Espaço",
  "Fais un dash": "Dê um impulso",
  "Fermer": "Fechar",
  "Fin": "End",
  "Fin de partie": "Fim da partida",
  "Frappe autour": "Bate ao redor",
  "Frappe devant": "Bate na frente",
  "Frappe loin": "Bate longe",
  "Frisbee": "Frisbee",
  "Frisbees en passes": "Passes de Frisbee",
  "Full festival": "Full festival",
  "Fusion": "Fusão",
  "Gauche": "Esquerda",
  "Glisse sur l’arène pour te déplacer": "Arraste na arena para andar",
  "Glisser son bouton": "Arrastar o botão",
  "Glisser sur l’arène": "Arrastar na arena",
  "Goa des étoiles": "Goa das Estrelas",
  "Générique": "Geral",
  "Haut": "Cima",
  "Hôte": "Anfitrião",
  "Idée": "Ideia",
  "Il attire les bad vibes, puis les repousse d’une onde.": "Atrai as bad vibes e depois as empurra com uma onda.",
  "Il enrôle les bad vibes en ronde autour de lui : elles prennent les coups.": "Junta as bad vibes numa roda ao seu redor: elas levam os golpes.",
  "Il filme la scène et éblouit doucement la zone de son écran.": "Filma o palco e ofusca de leve a área da tela dele.",
  "Il fonce droit sur la scène et bouscule qui se met en travers.": "Corre direto para o palco e empurra quem entrar na frente.",
  "Il fonce sur tes vibes au sol, les vole, puis détale si tu le poursuis.": "Corre atrás das suas vibes no chão, rouba e foge se você for atrás.",
  "Il frappe en arc devant toi à chaque temps.": "Bate em arco na sua frente a cada tempo.",
  "Il frappe à l’aller, revient soigner un allié.": "Bate na ida e volta para curar um aliado.",
  "Il ne va pas bien : reste à son contact une mesure pour l'aider.": "Não está bem: fique do lado dele por um compasso para ajudar.",
  "Il reste loin et balance des bouteilles qui ralentissent qui les reçoit.": "Fica longe e joga garrafas que deixam lento quem recebe.",
  "Il s'accroche à toi et te ralentit jusqu'à ce qu'on le décroche.": "Gruda em você e te deixa lento até alguém tirar ele de cima.",
  "Il souffle, et tout ce qui est léger dérive.": "Sopra, e tudo o que é leve sai à deriva.",
  "Il surgit de partout à la fois, faible seul mais jamais seul.": "Surge de todo lado ao mesmo tempo, fraco sozinho mas nunca sozinho.",
  "Il va plus loin et plus vite, puis revient soigner un allié.": "Vai mais longe e mais rápido, e volta para curar um aliado.",
  "Il veut couper le son avant l'heure.": "Quer cortar o som antes da hora.",
  "Il éteint les bonus de qui reste trop près : vise-le en priorité.": "Apaga os bônus de quem fica perto demais: mire nele primeiro.",
  "Inser": "Insert",
  "Interruption": "Interrupção",
  "Inverser les sticks": "Inverter os analógicos",
  "Invité": "Convidado",
  "Jambes de danseur": "Pernas de Dançarino",
  "Jauge": "Medidor",
  "Jeu complet": "Jogo completo",
  "Jeu web léger de survie coopérative dans un festival de psytrance.": "Jogo web leve de sobrevivência cooperativa num festival de psytrance.",
  "Joindre le contexte": "Anexar o contexto",
  "Joue en continu": "Toca sem parar",
  "Jouer": "Jogar",
  "Joueur {number}": "Jogador {number}",
  "Jusqu’à 4 joueurs": "Até 4 jogadores",
  "Kiff": "Curtição",
  "L'Arnaqueur": "O Trambiqueiro",
  "L'Hygie": "A Hygie",
  "L'Intolérant": "O Intolerante",
  "La Batterie à plat": "A Bateria Descarregada",
  "La Forêt": "A Floresta",
  "La Grenouille acide": "A Rã Ácida",
  "La Luxiole": "A Luxiole",
  "La musique s’arrête": "A música para",
  "La partie a déjà commencé": "A partida já começou",
  "La piste t’attend": "A pista te espera",
  "La soirée d'ouverture": "A Noite de Abertura",
  "Lance le set": "Começa o set",
  "Lance ta spéciale": "Use sua especial",
  "Lancer la nuit": "Começar a noite",
  "Lancer le festival": "Começar o festival",
  "Lancer le set": "Começar o set",
  "Lancé sur le 1, il retombe sur les bad vibes et claque.": "Lançado no 1, cai sobre as bad vibes e estoura.",
  "Langue": "Idioma",
  "Langues du jeu": "Idiomas do jogo",
  "Laser": "Laser",
  "Le Babacool": "O Bicho-Grilo",
  "Le Bavard": "O Tagarela",
  "Le Cercle acid": "O Círculo Acid",
  "Le Circadien": "O Circadiano",
  "Le Collant": "O Grudento",
  "Le Coup de vent": "A Rajada",
  "Le Couvre-feu": "O Toque de Recolher",
  "Le Céleste": "O Celeste",
  "Le Dome": "O Dome",
  "Le Désagréable": "O Grosso",
  "Le Dôme chill": "A Cúpula Chill",
  "Le Fatigué": "O Sonolento",
  "Le Festivalier en détresse": "O Festeiro em Apuros",
  "Le Filmeur": "O Filmador",
  "Le Jongleur": "O Malabarista",
  "Le Kiffeur": "O Curtidor",
  "Le Mâle alpha": "O Macho Alfa",
  "Le Méprisant": "O Esnobe",
  "Le Nounours": "O Nounours",
  "Le Pogo": "O Pogo",
  "Le Poussin": "O Pintinho",
  "Le Random": "O Aleatório",
  "Le Sportif": "O Atleta",
  "Le Sub": "O Sub",
  "Le Super fan": "O Superfã",
  "Le Tatoué": "O Tatuado",
  "Le Veilleur aux lucioles": "O Vigia dos Vaga-lumes",
  "Le Zombie": "O Zumbi",
  "Le boss lâche une relique": "O chefão deixa uma relíquia",
  "Le formulaire GitHub est ouvert": "O formulário do GitHub está aberto",
  "Le jeu se recharge": "O jogo recarrega",
  "Le lien avec les autres joueurs est coupé.": "A conexão com os outros jogadores caiu.",
  "Le lève-tôt du petit matin : abats-le, il se relève une fois.": "O madrugador do amanhecer: derrube ele, que levanta uma vez.",
  "Le poser ailleurs": "Colocar em outro lugar",
  "Le salon existe, mais vos réseaux n’arrivent pas à se joindre": "A sala existe, mas as redes de vocês não conseguem se conectar",
  "Le set continue": "O set continua",
  "Le set est allé au bout, puis le sound system a tenu {duration} de sans-fin. On y retourne ?": "O set foi até o fim e o sound system aguentou {duration} de modo sem fim. Bora de novo?",
  "Le set reprend là où tu l’as laissé.": "O set continua de onde você parou.",
  "Le set se joue en paysage.": "O set é jogado na horizontal.",
  "Le set s’arrête pour tout le monde plutôt que de continuer de travers. Le rapport est prêt pour « Ton avis ».": "O set para para todo mundo em vez de continuar fora de sincronia. O relatório está pronto em “Sua opinião”.",
  "Le set s’arrête pour toute l’équipe, sans score : chacun peut changer de perso.": "O set acaba para toda a equipe, sem pontuação: cada um pode trocar de personagem.",
  "Le set va jusqu’au dernier boss, puis la nuit repart : elle s’arrête quand vous tombez.": "O set vai até o último chefão, depois a noite recomeça: ela acaba quando vocês caem.",
  "Le soleil se lève sur le dancefloor. Le sound system a tenu toute la nuit.": "O sol nasce na pista. O sound system aguentou a noite toda.",
  "Le sound system tient bon, mais les bad vibes ont vidé la piste. On se relève et on y retourne ?": "O sound system aguenta, mas as bad vibes esvaziaram a pista. Bora levantar e tentar de novo?",
  "Le totem envoie une onde sur chaque kick.": "O totem solta uma onda a cada kick.",
  "Les autres scènes suivent : à chaque sunrise, l’équipe choisit sa sortie.": "Os outros palcos vêm depois: a cada sunrise, a equipe escolhe sua saída.",
  "Les bad vibes ont eu raison du sound system. On rebranche et on y retourne ?": "As bad vibes venceram o sound system. Bora religar e tentar de novo?",
  "Les bad vibes qu’il traverse encaissent plus de coups.": "As bad vibes que ele atravessa levam mais dano.",
  "Les bad vibes y ralentissent": "Ali as bad vibes ficam lentas",
  "Les bad vibes y sont marquées": "Ali as bad vibes ficam marcadas",
  "Les deux versions de la partie ont divergé": "As duas cópias da partida saíram de sincronia",
  "Les joueurs": "Os jogadores",
  "Les lucioles veillent sur toi": "Os vaga-lumes cuidam de você",
  "Les pièges freinent les bad vibes": "As armadilhas freiam as bad vibes",
  "Les quatre scènes, d’un chemin à l’autre": "Os quatro palcos, de caminho em caminho",
  "Libre": "Livre",
  "Lien copié, envoie-le à tes amis.": "Link copiado, mande para seus amigos.",
  "Lien sélectionné : copie-le avec Ctrl+C.": "Link selecionado: copie com Ctrl+C.",
  "Line-up": "Line-up",
  "Lourd et sûr de lui, il pousse ton matériel et encaisse moitié moins de face : prends-le à revers.": "Pesado e convencido, empurra seu equipamento e leva metade do dano de frente: pegue ele por trás.",
  "Lumière traversante": "Luz Perfurante",
  "Légendaire": "Lendária",
  "L’Avatar": "O Avatar",
  "L’Enraciné": "O Enraizado",
  "L’after": "O after",
  "L’hôte a fermé le salon": "O anfitrião fechou a sala",
  "L’hôte a quitté le set": "O anfitrião saiu do set",
  "L’hôte choisit la scène": "O anfitrião escolhe o palco",
  "L’équipe": "A equipe",
  "Machine à fumée": "Máquina de Fumaça",
  "Main libre": "Mão livre",
  "Main stage": "Main stage",
  "Maj": "Shift",
  "Maj droite": "Shift direito",
  "Maj+Tab": "Shift+Tab",
  "Manette": "Controle",
  "Manette {number}": "Controle {number}",
  "Marcher au stick droit, viser au gauche": "Andar com o analógico direito, mirar com o esquerdo",
  "Marque": "Marca",
  "Menu de pause": "Menu de pausa",
  "Menu principal": "Menu principal",
  "Mode calme": "Modo calmo",
  "Mode calme, commandes, langue": "Modo calmo, controles, idioma",
  "Mode de jeu": "Modo de jogo",
  "Molette": "Roda",
  "Molette ↑": "Roda ↑",
  "Molette ↓": "Roda ↓",
  "Monocycle": "Monociclo",
  "Monocycle filant": "Monociclo Cadente",
  "Monocycle réparateur": "Monociclo Reparador",
  "Monter le son": "Aumentar o som",
  "Montée": "Subida",
  "Musique et effets": "Música e efeitos",
  "Même écran": "Mesma tela",
  "Même écran ou en ligne": "Mesma tela ou online",
  "Ne vise pas, il danse : sa bonne humeur frappe tout autour de lui et fait tirer plus vite.": "Não mira, dança: o bom humor dele bate em tudo ao redor e faz atirar mais rápido.",
  "Niv. {level}": "Nv. {level}",
  "Niveau": "Nível",
  "Niveau supérieur": "Subiu de nível",
  "Niveau {level}": "Nível {level}",
  "Niveau {level} : {vibes} vibes sur {next}": {
    "one": "Nível {level}: {vibes} de {next} vibe",
    "many": "Nível {level}: {vibes} de {next} vibes",
    "other": "Nível {level}: {vibes} de {next} vibes"
  },
  "Niveau {level} sur {max}": "Nível {level} de {max}",
  "Nom": "Nome",
  "Nom du joueur {number}": "Nome do jogador {number}",
  "Non": "Não",
  "Nouveau": "Novo",
  "Nouveau record !": "Novo recorde!",
  "Nova": "Nova",
  "Ola": "Ola",
  "Ola déchaînée": "Ola Desenfreada",
  "Ola sans fin": "Ola Sem Fim",
  "Oui": "Sim",
  "Page ↑": "Page ↑",
  "Page ↓": "Page ↓",
  "Palier {tier} / {count}": "Fase {tier} / {count}",
  "Palier {tier}, drop": "Fase {tier}, drop",
  "Par où commence la nuit ?": "Por onde começa a noite?",
  "Partie interrompue": "Partida interrompida",
  "Pas chassé": "Passo Chassé",
  "Pas de compte GitHub ? Copie ton avis pour l’envoyer autrement.": "Sem conta no GitHub? Copie sua opinião para mandar de outro jeito.",
  "Pas de réponse : réessaie, ou vérifie le code": "Sem resposta: tente de novo ou confira o código",
  "Pas sur GitHub ?": "Não está no GitHub?",
  "Passe dans les coulisses sur Discord": "Venha pro backstage no Discord",
  "Pause": "Pausa",
  "Pavé {number}": "Num {number}",
  "Phrases tenues": "Frases aguentadas",
  "Piège précédent": "Armadilha anterior",
  "Piège suivant": "Próxima armadilha",
  "Pièges": "Armadilhas",
  "Place {place} sur {slots}": "Espaço {place} de {slots}",
  "Pluie de diabolos": "Chuva de Diabolôs",
  "Plus aucun signe de l’hôte depuis {seconds} secondes.": {
    "one": "Nenhum sinal do anfitrião há {seconds} segundo.",
    "many": "Nenhum sinal do anfitrião há {seconds} segundos.",
    "other": "Nenhum sinal do anfitrião há {seconds} segundos."
  },
  "Plus de place pour un piège : reprends-en un": "Sem espaço para outra armadilha: pegue uma de volta",
  "Plus personne debout": "Ninguém de pé",
  "Portée": "Alcance",
  "Pose ton mot sur Discord": "Deixe seu recado no Discord",
  "Pose un piège": "Coloque uma armadilha",
  "Poser le piège": "Pôr a armadilha",
  "Poser un piège à ses pieds": "Colocar uma armadilha aos seus pés",
  "Pour rejouer ta partie à l’identique": "Para repetir sua partida igualzinha",
  "Progressive": "Progressive",
  "Projecteur de poursuite": "Canhão Seguidor",
  "Prêt": "Pronto",
  "Prête": "Pronta",
  "Psychill, ambient": "Psychill, ambient",
  "Psytrance full-on": "Psytrance full-on",
  "Pumpui": "Pumpui",
  "Quelle nuit !": "Que noite!",
  "Qui monte sur la piste ce soir ?": "Quem sobe na pista hoje?",
  "Quitter": "Sair",
  "Quitter la partie": "Sair da partida",
  "Quitter le salon": "Sair da sala",
  "Quitter le set ?": "Sair do set?",
  "Raconte-nous ta soirée": "Conte como foi sua noite",
  "Ralentit": "Freia",
  "Rallonge": "Extensão",
  "Ramasse les vibes": "Pegue as vibes",
  "Rang {rank}": "Nível {rank}",
  "Rang {rank} sur {max}": "Nível {rank} de {max}",
  "Rare": "Rara",
  "Recharge": "Recarga",
  "Recharge la page": "Recarregue a página",
  "Record : {score}": "Recorde: {score}",
  "Recrute tes roadies sur Discord": "Chame seus roadies no Discord",
  "Rejoindre": "Entrar",
  "Rejouer": "Jogar de novo",
  "Relique": "Relíquia",
  "Relis ton avis dans le nouvel onglet, puis publie-le. Il te faut un compte GitHub.": "Revise sua opinião na nova aba e publique. Você precisa de uma conta no GitHub.",
  "Remettre par défaut": "Restaurar padrão",
  "Remplace {weapon}": "Substitui {weapon}",
  "Remplis ta jauge de vibes, puis choisis une amélioration": "Encha seu medidor de vibes e depois escolha uma melhoria",
  "Repousse": "Empurra",
  "Reprendre": "Continuar",
  "Reprendre : {trap}": "Pegar de volta: {trap}",
  "Reste deux mesures pour brancher": "Faltam dois compassos para ligar",
  "Reste près d’une enceinte pour la brancher": "Fique perto de uma caixa para ligá-la",
  "Reste quatre mesures pour brancher": "Faltam quatro compassos para ligar",
  "Reste trois mesures pour brancher": "Faltam três compassos para ligar",
  "Reste une mesure pour brancher": "Falta um compasso para ligar",
  "Reste zéro mesure pour brancher": "Não falta nenhum compasso para ligar",
  "Reste {bars} mesures pour brancher": {
    "one": "Falta {bars} compasso para ligar",
    "many": "Faltam {bars} compassos para ligar",
    "other": "Faltam {bars} compassos para ligar"
  },
  "Rester": "Ficar",
  "Retour": "Voltar",
  "Retour arrière": "Backspace",
  "Retour au perso": "Voltar ao personagem",
  "Retour au salon": "Voltar à sala",
  "Retour au salon ?": "Voltar à sala?",
  "Retour au titre": "Voltar ao título",
  "Ruban arc-en-ciel": "Fita Arco-Íris",
  "Réessayer": "Tentar de novo",
  "Réglages": "Ajustes",
  "Salon": "Sala",
  "Salon en ligne": "Sala online",
  "Salon local": "Sala local",
  "Salon plein": "Sala cheia",
  "Sans fin": "Sem fim",
  "Sans lui, le sound system s’éteint.": "Sem ele, o sound system apaga.",
  "Sans strobos, secousses ni halos forts": "Sem estrobos, tremores nem halos",
  "Sans tenir le tir": "Sem segurar o tiro",
  "Score": "Pontuação",
  "Scène": "Palco",
  "Scène du départ": "Palco inicial",
  "Scènes": "Palcos",
  "Se déplacer": "Andar",
  "Ses bulles de blabla s'affichent et masquent un bout de ton écran.": "Os balões de papo dele aparecem e tampam parte da sua tela.",
  "Ses zones freinent les bad vibes et soignent tes alliés.": "Suas zonas freiam as bad vibes e curam seus aliados.",
  "Soigne": "Cura",
  "Soigne, répare la scène et relève ses amis.": "Cura, conserta o palco e levanta os amigos.",
  "Soin": "Cura",
  "Son": "Som",
  "Son bâillement se propage autour de lui, puis il s'endort sur place.": "O bocejo dele se espalha em volta e depois ele dorme ali mesmo.",
  "Son des coups": "Som dos golpes",
  "Sono de référence": "Som de Referência",
  "Souffle un cône de brume qui balaie la piste, soigne sur chaque temps et ralentit les bad vibes.": "Sopra um cone de névoa que varre a pista, cura a cada tempo e deixa as bad vibes lentas.",
  "Souris": "Mouse",
  "Spéciale": "Especial",
  "Spéciale XXL": "Especial XXL",
  "Stick droit": "Analógico direito",
  "Stick gauche": "Analógico esquerdo",
  "Sub renforcé": "Sub Reforçado",
  "Sunrise": "Sunrise",
  "Sunrise !": "Sunrise!",
  "Sur le drop, il traverse tout l’écran et marque tout.": "No drop, atravessa a tela toda e marca tudo.",
  "Sur le drop, une pluie de diabolos tombe sur tout l’écran.": "No drop, uma chuva de diabolôs cai na tela toda.",
  "Ta Ola frappe deux fois plus fort.": "Sua ola bate duas vezes mais forte.",
  "Ta Ola frappe plus fort.": "Sua ola bate mais forte.",
  "Ta Ola frappe trois fois plus fort.": "Sua ola bate três vezes mais forte.",
  "Ta spéciale frappe deux fois plus fort.": "Sua especial bate duas vezes mais forte.",
  "Ta spéciale frappe plus fort.": "Sua especial bate mais forte.",
  "Ta spéciale frappe trois fois plus fort.": "Sua especial bate três vezes mais forte.",
  "Ta spéciale revient bien plus vite.": "Sua especial volta bem mais rápido.",
  "Ta spéciale revient plus vite.": "Sua especial volta mais rápido.",
  "Ta spéciale revient presque aussitôt.": "Sua especial volta quase na hora.",
  "Ta spéciale revient presque en continu.": "Sua especial volta quase sem parar.",
  "Tactile": "Toque",
  "Talkie-walkie": "Walkie-Talkie",
  "Temps": "Tempo",
  "Tes agrès : {places}": "Seus aparelhos: {places}",
  "Tes pièges font deux fois et demie plus de dégâts.": "Suas armadilhas causam duas vezes e meia mais dano.",
  "Tes pièges font deux fois plus de dégâts.": "Suas armadilhas causam o dobro de dano.",
  "Tes pièges font plus de dégâts.": "Suas armadilhas causam mais dano.",
  "Tes pièges frappent fort et loin, et tes loots abondent.": "Suas armadilhas batem forte e longe, e o loot chove.",
  "Tes pièges frappent plus fort et couvrent plus de piste.": "Suas armadilhas batem mais forte e cobrem mais pista.",
  "Tes tirs font deux fois plus de dégâts.": "Seus tiros causam o dobro de dano.",
  "Tes tirs font nettement plus de dégâts.": "Seus tiros causam bem mais dano.",
  "Tes tirs font plus de dégâts.": "Seus tiros causam mais dano.",
  "Tes tirs traversent deux bad vibes de plus.": "Seus tiros atravessam mais duas bad vibes.",
  "Tes tirs traversent quatre bad vibes de plus.": "Seus tiros atravessam mais quatro bad vibes.",
  "Tes tirs traversent six bad vibes de plus.": "Seus tiros atravessam mais seis bad vibes.",
  "Tes tirs vont plus vite, traversent plus et frappent fort.": "Seus tiros vão mais rápido, atravessam mais e batem forte.",
  "Tient la ligne et attire les bad vibes. Lent.": "Segura a linha e atrai as bad vibes. Lento.",
  "Tir automatique": "Tiro automático",
  "Tire": "Atire",
  "Tire sur les doubles croches {steps}": "Atira nas semicolcheias {steps}",
  "Tire sur les doubles croches {steps}, une mesure sur {bars}": {
    "one": "Atira nas semicolcheias {steps}, um compasso a cada {bars}",
    "many": "Atira nas semicolcheias {steps}, um compasso a cada {bars}",
    "other": "Atira nas semicolcheias {steps}, um compasso a cada {bars}"
  },
  "Tirer": "Atirar",
  "Toi": "Você",
  "Toi · hôte": "Você · anfitrião",
  "Ton Kiff au max double la force de ta bonne humeur.": "Sua Curtição no máximo dobra a força do seu bom humor.",
  "Ton Kiff fait frapper ta bonne humeur nettement plus fort.": "Sua Curtição faz seu bom humor bater muito mais forte.",
  "Ton Kiff fait frapper ta bonne humeur plus fort.": "Sua Curtição faz seu bom humor bater mais forte.",
  "Ton aura s’élargit nettement.": "Sua aura aumenta bastante.",
  "Ton aura s’élargit.": "Sua aura aumenta.",
  "Ton aura s’étend de moitié.": "Sua aura cresce metade a mais.",
  "Ton avis": "Sua opinião",
  "Ton avis sera public sur GitHub. N’y mets rien de personnel.": "Sua opinião vai ser pública no GitHub. Não coloque nada pessoal.",
  "Ton dash revient bien plus vite.": "Seu impulso volta bem mais rápido.",
  "Ton dash revient nettement plus vite.": "Seu impulso volta muito mais rápido.",
  "Ton dash revient plus vite.": "Seu impulso volta mais rápido.",
  "Ton message était trop long pour le lien, sa fin a été coupée. Copie-le en entier pour le coller sur GitHub.": "Sua mensagem era longa demais para o link e o fim foi cortado. Copie inteira para colar no GitHub.",
  "Ton navigateur a bloqué le nouvel onglet. Réessaie, ou copie ton avis pour ne pas le perdre.": "Seu navegador bloqueou a nova aba. Tente de novo ou copie sua opinião para não perder.",
  "Ton onglet a pris trop de retard.": "Sua aba ficou atrasada demais.",
  "Totem": "Totem",
  "Totem sono": "Totem Sonoro",
  "Touche le bouton de ta spéciale": "Toque no botão da sua especial",
  "Touche le bouton du dash": "Toque no botão do impulso",
  "Touche le bouton du piège pour le poser": "Toque no botão da armadilha para colocá-la",
  "Touche le bouton d’un piège pour le poser à tes pieds": "Toque no botão de uma armadilha para colocá-la aos seus pés",
  "Toucher": "Tocar",
  "Toucher son bouton": "Tocar o botão",
  "Touches par défaut remises.": "Teclas padrão restauradas.",
  "Toujours là : Start pour la pause, la croix pour les gestes, A et B dans les menus.": "Sempre valem: Start para pausar, o direcional para os gestos, A e B nos menus.",
  "Toujours là : Échap pour la pause, 1 à 5 pour les pièges, les flèches et Entrée dans les menus.": "Sempre valem: Esc para pausar, 1 a 5 para as armadilhas, as setas e Enter nos menus.",
  "Tourne ton téléphone": "Vire o celular",
  "Trois cerceaux, chacun frappe comme ta spéciale.": "Três bambolês, cada um bate como sua especial.",
  "Trouve ton crew": "Ache sua galera",
  "Tu as rejoint le salon {code}.": "Você entrou na sala {code}.",
  "Tu attires les vibes de bien plus loin.": "Você atrai as vibes de bem mais longe.",
  "Tu attires les vibes de plus loin.": "Você atrai as vibes de mais longe.",
  "Tu attires les vibes de très loin.": "Você atrai as vibes de muito longe.",
  "Tu attires les vibes, tires plus et frappes plus fort.": "Você atrai as vibes, atira mais e bate mais forte.",
  "Tu deviens plus solide et tu glisses plus vite.": "Você fica mais resistente e desliza mais rápido.",
  "Tu fais venir les porteurs de loot deux fois plus souvent.": "Os portadores de loot aparecem duas vezes mais.",
  "Tu fais venir les porteurs de loot plus souvent.": "Os portadores de loot aparecem mais vezes.",
  "Tu fais venir les porteurs de loot trois fois plus souvent.": "Os portadores de loot aparecem três vezes mais.",
  "Tu files plus vite ; ta traînée freine plus et soigne mieux.": "Você vai mais rápido; seu rastro freia mais e cura melhor.",
  "Tu fonces devant toi, intouchable, et les bad vibes alentour ne voient plus que toi.": "Você avança intocável, e as bad vibes em volta só enxergam você.",
  "Tu gagnes 120 points de vie maximum.": "Você ganha 120 pontos de vida máxima.",
  "Tu gagnes 40 points de vie maximum.": "Você ganha 40 pontos de vida máxima.",
  "Tu gagnes 80 points de vie maximum.": "Você ganha 80 pontos de vida máxima.",
  "Tu laisses les autres joueurs : ton personnage reste immobile et le set continue sans toi.": "Você deixa os outros: seu personagem fica parado e o set continua sem você.",
  "Tu libères une onde de lumière qui repousse les bad vibes autour de toi.": "Você solta uma onda de luz que afasta as bad vibes ao seu redor.",
  "Tu marches au stick droit et tu vises au gauche.": "Você anda com o analógico direito e mira com o esquerdo.",
  "Tu marches au stick gauche et tu vises au droit.": "Você anda com o analógico esquerdo e mira com o direito.",
  "Tu peux enchaîner deux dashs de plus.": "Você pode encadear mais dois impulsos.",
  "Tu peux enchaîner trois dashs de plus.": "Você pode encadear mais três impulsos.",
  "Tu peux enchaîner un dash de plus.": "Você pode encadear mais um impulso.",
  "Tu peux poser deux pièges de plus.": "Você pode colocar mais duas armadilhas.",
  "Tu peux poser quatre pièges de plus.": "Você pode colocar mais quatro armadilhas.",
  "Tu peux poser six pièges de plus.": "Você pode colocar mais seis armadilhas.",
  "Tu ramasses les loots de bien plus loin.": "Você pega o loot de bem mais longe.",
  "Tu ramasses les loots de plus loin.": "Você pega o loot de mais longe.",
  "Tu ramasses les loots de très loin.": "Você pega o loot de muito longe.",
  "Tu rentres avant le sunrise : la partie s’arrête ici, sans score.": "Você vai embora antes do sunrise: a partida acaba aqui, sem pontuação.",
  "Tu roules vite ; ta traînée freine les bad vibes et soigne.": "Você roda rápido; seu rastro freia as bad vibes e cura.",
  "Tu sais jouer. Tiens jusqu’au sunrise !": "Você já sabe jogar. Aguente até o sunrise!",
  "Tu soignes ceux qui sont près de toi et tu répares un peu la scène.": "Você cura quem está perto e conserta um pouco o palco.",
  "Tu te déplaces bien plus vite.": "Você anda bem mais rápido.",
  "Tu te déplaces nettement plus vite.": "Você anda muito mais rápido.",
  "Tu te déplaces plus vite.": "Você anda mais rápido.",
  "Tu tires bien plus souvent.": "Você atira bem mais vezes.",
  "Tu tires deux projectiles de plus.": "Você atira mais dois projéteis.",
  "Tu tires nettement plus souvent.": "Você atira muito mais vezes.",
  "Tu tires plus souvent et ta spéciale revient plus vite.": "Você atira mais vezes e sua especial volta mais rápido.",
  "Tu tires plus souvent.": "Você atira mais vezes.",
  "Tu tires quatre projectiles de plus.": "Você atira mais quatro projéteis.",
  "Tu tires six projectiles de plus.": "Você atira mais seis projéteis.",
  "Un bâton, à jeter au feu": "Um tronco, para jogar na fogueira",
  "Un cerceau tourne autour de toi, repousse et s’élargit.": "Um bambolê gira ao seu redor, empurra e se alarga.",
  "Un joueur": "Um jogador",
  "Un set, jusqu’au sunrise": "Um set, até o sunrise",
  "Une brume qui te soigne": "Uma névoa que te cura",
  "Une idée, un bug ? Dis-le-nous": "Uma ideia, um bug? Conta pra gente",
  "Une note par coup porté": "Uma nota a cada golpe",
  "Une onde de choc par kick": "Uma onda de choque a cada kick",
  "Une scène": "Um palco",
  "Une vague part de toi, ralentit les bad vibes et fait courir et tirer plus vite toute l’équipe.": "Uma onda sai de você, desacelera as bad vibes e faz a equipe toda correr e atirar mais rápido.",
  "Ventilateur brumisant": "Ventilador de Névoa",
  "Verr. maj": "Caps Lock",
  "Vers la bad vibe à portée": "Na bad vibe ao alcance",
  "Vibes": "Vibes",
  "Vie": "Vida",
  "Vie de la scène": "Vida do palco",
  "Viser": "Mirar",
  "Viser et tirer": "Mirar e atirar",
  "Visée automatique": "Mira automática",
  "Vitesse": "Velocidade",
  "Volume à fond": "Volume no Talo",
  "annuler": "cancelar",
  "apprendre": "aprender",
  "aucune": "nenhuma",
  "avant : {score}": "antes: {score}",
  "avec {first} ou {second}, il fusionne": "com {first} ou {second}, ele se funde",
  "avec {upgrade}, devient {fusion}": "com {upgrade}, vira {fusion}",
  "changer": "trocar",
  "choisir": "escolher",
  "classe": "classe",
  "classe, scène": "classe, palco",
  "départ {stage} · {count} scènes · {length}": "saindo de {stage} · {count} palcos · {length}",
  "fermer": "fechar",
  "lancer": "começar",
  "mode": "modo",
  "naviguer": "navegar",
  "niv. {level}": "nív. {level}",
  "ou rejoins le salon d’un ami": "ou entre na sala de um amigo",
  "pose le piège à tes pieds": "coloque a armadilha aos seus pés",
  "quitter": "sair",
  "quitter sa place": "sair do lugar",
  "recharge {duration}": "recarga {duration}",
  "rejoindre": "entrar",
  "reprendre": "continuar",
  "retour": "voltar",
  "sans fin": "sem fim",
  "scène": "palco",
  "son": "som",
  "tant que vous tenez": "enquanto vocês aguentarem",
  "valider": "confirmar",
  "vider": "limpar",
  "{action} : appuie sur un bouton de la manette.": "{action}: aperte um botão do controle.",
  "{action} : appuie sur une touche, un bouton de la souris ou la molette.": "{action}: aperte uma tecla, um botão do mouse ou a roda.",
  "{action} : case vidée.": "{action}: campo limpo.",
  "{action}, touche {number} : {key}": "{action}, campo {number}: {key}",
  "{count} alliés soignés": {
    "one": "{count} aliado curado",
    "many": "{count} aliados curados",
    "other": "{count} aliados curados"
  },
  "{count} bad vibes": {
    "one": "{count} bad vibe",
    "many": "{count} bad vibes",
    "other": "{count} bad vibes"
  },
  "{count} boss": {
    "one": "{count} chefão",
    "many": "{count} chefões",
    "other": "{count} chefões"
  },
  "{count} cartes": {
    "one": "{count} carta",
    "many": "{count} cartas",
    "other": "{count} cartas"
  },
  "{count} vibes": {
    "one": "{count} vibe",
    "many": "{count} vibes",
    "other": "{count} vibes"
  },
  "{count} visites": {
    "one": "{count} visita",
    "many": "{count} visitas",
    "other": "{count} visitas"
  },
  "{hp} sur {maxHp}": "{hp} de {maxHp}",
  "{key} va à {action} et quitte {other}.": "{key} vai para {action} e sai de {other}.",
  "{key} va à {action}, {other} prend {old}.": "{key} vai para {action}, {other} fica com {old}.",
  "{key} va à {action}.": "{key} vai para {action}.",
  "{names} et {last}": "{names} e {last}",
  "{name} : {card}": "{name}: {card}",
  "{name} : {description}": "{name}: {description}",
  "{name} a quitté le set": "{name} saiu do set",
  "{name} choisit…": "{name} está escolhendo…",
  "{name}, dans le jeu complet": "{name}, no jogo completo",
  "{percent} %": "{percent}%",
  "{percent} %": "{percent}%",
  "{plugged} enceintes branchées sur {total}": {
    "one": "{plugged} de {total} caixas ligadas",
    "many": "{plugged} de {total} caixas ligadas",
    "other": "{plugged} de {total} caixas ligadas"
  },
  "{role}, que tes agrès ne font pas encore": "{role}, o que seus aparelhos ainda não fazem",
  "{skill} : en recharge": "{skill}: recarregando",
  "{skill} : prête": "{skill}: pronta",
  "{taken}/{capacity}": "{taken}/{capacity}",
  "{value} sur {max}": "{value} de {max}",
  "{weapon} + {upgrade}": "{weapon} + {upgrade}",
  "{weapon}, niveau {level}": "{weapon}, nível {level}",
  "À distance": "Remoto",
  "À fond": "No talo",
  "À plusieurs": "Com amigos",
  "À terre": "Caído",
  "Échap": "Esc",
  "Éclats de rire": "Gargalhadas",
  "Écran titre": "Tela de título",
  "Écris ton avis avant de l’envoyer.": "Escreva sua opinião antes de enviar.",
  "Équilibrage": "Equilíbrio",
  "Éventails de feu": "Leques de Fogo",
  "≈ {minutes} min": "≈ {minutes} min"
}
